import Set from './Set'

/**
 * @see http://download.oracle.com/javase/6/docs/api/java/util/SortedSet.html
 */
export default class SortedSet extends Set {}
